/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ContactPreview;
(function (ContactPreview) {
    let ats;
    (function (ats) {
        ats["LEVER"] = "Lever";
        ats["GREENHOUSE"] = "Greenhouse";
        ats["ASHBY"] = "Ashby";
        ats["RECRUITERFLOW"] = "Recruiterflow";
        ats["CLOCKWORK"] = "Clockwork";
        ats["BULLHORN"] = "Bullhorn";
        ats["ORACLE_TALEO"] = "Oracle Taleo";
        ats["WORKDAY"] = "Workday";
    })(ats = ContactPreview.ats || (ContactPreview.ats = {}));
})(ContactPreview || (ContactPreview = {}));
